import {
  Form,
  Button,
  Image,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useHistory } from "react-router";
import { faBan, faCheck, faSave } from "@fortawesome/pro-light-svg-icons";
import {
  formFields,
  getPathWithParam,
  MANAGE_FEE_ROUTES,
  manageFeeFormNames,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  toOptionValuesFromMapper,
  feeRunTypeOptions,
  statusOptions,
  toMultiSelectValueById,
  sectionTypeOptions,
  EMPLOYEE_RECORDS_TO_FETCH,
  FLOW_TYPES,
} from "../../../utils";
import React, { useContext, useEffect, useState } from "react";
import {
  FeeHomeCard,
  FieldButtonGroup,
  FieldDropSide,
  FieldMultiSelectButtonGroup,
  FormControlSearch,
  LoaderWrapper,
  ManageFeeLayout,
  MultiSelectDropdown,
  SliderPanel,
  Link,
  SearchableList,
} from "../../../components";
import { Field, Formik } from "formik";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getFeeClassifications,
  getFeeDetailsBySearchCriteria,
  getPlansBySearchCriteria,
} from "../../../services";
import { isEmpty } from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import { useDeepEffect } from "../../../abstracts";
const ManageFeeContainer = (props) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [feeData, setFeeData] = useState([]);
  const [tags, setTags] = useState([]);
  const [showTags, setshowTags] = useState(false);
  const [filterSlider, setFilterSlider] = useState(false);
  const [feeClassificationsList, setFeeClassificationsList] = useState([]);
  const [plans, setPlans] = useState([]);
  const [planNameOrId, setPlanNameOrId] = useState(1);
  const [flatTags, setFlatTags] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [onSearchClick, setOnSearchClick] = useState(false);
  const [request, setRequest] = useState({
    searchString: "",
    from: 0,
    numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
    feeType: [],
    feeClassificationIds: [],
    feeRunType: 0,
    feeStatus: 0,
    planId: 0,
  });
  const feeTypeOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.FEES_TYPE
  );
  const formName = manageFeeFormNames.FEE_FILTER_FORM;
  const fields = formFields[formName];
  let initialValues = {
    from: request?.from,
    numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
    [fields.searchString]: request?.searchString,
    [fields.feeType]: request?.feeType,
    [fields.feeClassificationIds]: request?.feeClassificationIds,
    [fields.feeRunType]: request?.feeRunType,
    [fields.feeStatus]: request?.feeStatus,
    [fields.planId]: request?.planId,
    [fields.planNameOrId]: 1,
  };
  useDeepEffect(() => {
    setIsLoading(true);
    getFeeDetailsBySearchCriteria(request)
      .then((response) => {
        if (response.isSuccessfull) {
          if (response?.feeCardDetails?.length < EMPLOYEE_RECORDS_TO_FETCH)
            setStopInfiniteScroll(true);
          if (append) {
            setFeeData((feeDetailList) => {
              return [...feeDetailList, ...response.feeCardDetails];
            });
          } else {
            setFeeData(response.feeCardDetails);
          }
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }, [request, onSearchClick]);
  const feeTypeLength = tags[1]?.[0]?.length ?? 0;
  const feeClassificationLength = tags[2]?.[0]?.length ?? 0;
  const scheduleTypeLength = tags[3]?.[0]?.length ?? 0;
  const feeStatusLength = tags[4]?.[0]?.length ?? 0;
  const planLength = tags[5]?.[0]?.length ?? 0;
  useEffect(() => {
    if (filterSlider) {
      var payload = {
        planStatus: [],
        planType: [],
        investmentType: [],
        advisorsId: [],
        trusteesId: [],
        custodiansId: [],
        investmentsId: [],
      };
      getPlansBySearchCriteria(payload).then((responce) => {
        setPlans(responce);
      });
      getFeeClassifications().then((res) => {
        setFeeClassificationsList(res);
      });
    }
  }, [filterSlider]);

  const planSearchOptions = [
    {
      label: "Plan ID",
      value: 1,
    },
    {
      label: "Plan Name",
      value: 2,
    },
  ];

  var planNamedropdown = plans?.map((item) => {
    return {
      label: item.name,
      value: item.id,
    };
  });

  var planRkplandropdown = plans?.map((item) => {
    return {
      label: item.rkPlanNumber,
      value: item.id,
    };
  });

  var feeClassificationsResult = feeClassificationsList?.map((item) => {
    return {
      label: item.name,
      value: item.id,
    };
  });
  const filters = [
    feeTypeOptions,
    feeClassificationsResult,
    feeRunTypeOptions,
    statusOptions,
    planNameOrId == 1 ? planRkplandropdown : planNamedropdown,
  ];

  const onClickClearAll = (setFieldValue) => {
    setTags([]);
    setFieldValue(fields.feeType, []);
    setFieldValue(fields.feeClassificationIds, []);
    setFieldValue(fields.feeRunType, 0);
    setFieldValue(fields.feeStatus, 0);
    setFieldValue(fields.planId, 0);
  };

  const onDeleteFilterClick = (values, setFieldValue, index, itemIndex) => {
    let data = tags[index][0].filter((item) => item.value !== itemIndex);
    setTags({ ...tags, [index]: [data] });
    let ids = data.map((id) => id.value);
    switch (index) {
      case 1:
        setFieldValue(fields.feeType, ids);
        break;
      case 2:
        setFieldValue(fields.feeClassificationIds, ids);
        break;
      case 3:
        setFieldValue(fields.feeRunType, 0);
        break;
      case 4:
        setFieldValue(fields.feeStatus, 0);
        break;
      case 5:
        setFieldValue(fields.planId, 0);
        break;
    }
  };

  const handleFilters = (list, values) => {
    let data = filters[list - 1].filter((item) =>
      values?.map((x) => x).includes(item.value)
    );
    setTags({ ...tags, [list]: [data] });
  };

  const onFormSubmit = (values) => {
    setFilterSlider(false);
    setFlatTags(Object.values(tags).flat().flat());
    setAppend(false);
    setRequest({ ...values, from: 0 });
  };

  const buttons = [
    {
      label: "Create Fee",
      variant: "primary",
      type: "submit",
      onClick: () => {
        history.push(
          getPathWithParam({
            path: MANAGE_FEE_ROUTES.BASIC_DETAILS,
          })
        );
      },
    },
  ];
  const dataWidth = [
    { width: "30%", align: "left" },
    { width: "20%", align: "center" },
    { width: "15%", align: "center" },
    { width: "15%", align: "center" },
    { width: "20%", align: "center" },
    { width: "20%", align: "center" },
    { width: "15%", align: "center" },
  ];

  const header = [
    { name: "Fee Name & Description", width: "30%", align: "left" },
    { name: "Fee Classification", width: "20%", align: "center" },
    { name: "No. of Plan(s)", width: "15%", align: "center" },
    { name: "Fee Type", width: "15%", align: "center" },
    { name: "Fee Run Type", width: "20%", align: "center" },
    { name: "Next Run Date", width: "20%", align: "center" },
    { name: "Fee Status", width: "15%", align: "center" },
  ];
  const searchTextBox = (e) => {
    if (e.key === "Enter") {
      if (!isEmpty(e.target.value)) {
        setAppend(false);
      } else {
        setAppend(true);
        setFeeData([]);
        setOnSearchClick(!onSearchClick);
        setStopInfiniteScroll(false);
      }
      setRequest({
        searchString: e.target.value,
        from: 0,
        numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
        feeType: request?.feeType,
        feeClassificationIds: request?.feeClassificationIds,
        feeRunType: request?.feeRunType,
        feeStatus: request?.feeStatus,
        planId: request?.planId,
      });
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case "Active":
        return (
          <span className="isActive">
            <FontAwesomeIcon icon={faCheck} /> Active
          </span>
        );
      case "InActive":
        return (
          <span className="isInactive">
            <FontAwesomeIcon icon={faBan} /> Inactive
          </span>
        );
      case "Draft":
        return (
          <span className="isDraft">
            <FontAwesomeIcon icon={faSave} /> Draft
          </span>
        );
      default:
        return (
          <span className="isDraft">
            <FontAwesomeIcon icon={faSave} /> Draft
          </span>
        );
    }
  };

  const FeeDetailNavigate = (id, step) => {
    switch (step) {
      case 1:
        return history.push(
          getPathWithParam({
            path: MANAGE_FEE_ROUTES.CALCULATION,
            pathParam: [id],
          })
        );
      case 2:
        return history.push(
          getPathWithParam({
            path: MANAGE_FEE_ROUTES.APPLICABLE_TO,
            pathParam: [id],
          })
        );
      case 3:
        return history.push(
          getPathWithParam({
            //After construction of schedule page uncomment this.
            // path: MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
            path: MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
            pathParam: [id],
          })
        );
      case 4:
        return history.push(
          getPathWithParam({
            //After construction of summary page uncomment this.
            // path: MANAGE_FEE_ROUTES.SUMMARY,
            path: MANAGE_FEE_ROUTES.SUMMARY,
            pathParam: [id],
          })
        );
      case 5:
        return history.push(
          getPathWithParam({
            //After construction of summary page uncomment this.
            // path: MANAGE_FEE_ROUTES.SUMMARY,
            path: MANAGE_FEE_ROUTES.SUMMARY,
            pathParam: [FLOW_TYPES.EDIT, id],
          })
        );
      default:
        return history.push(
          getPathWithParam({
            path: MANAGE_FEE_ROUTES.BASIC_DETAILS,
            pathParam: [id],
          })
        );
    }
  };

  return (
    <ManageFeeLayout buttons={buttons}>
      <LoaderWrapper isLoading={isLoading} className="disableoverflow">
        <Formik
          onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
          initialValues={{
            ...initialValues,
          }}
        >
          {(formProps) => {
            const {
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setTouched,
              values,
              setSubmitting,
              setFieldError,
              fieldValue,
              ...rest
            } = formProps;
            return (
              <>
                <div className="d-flex justify-content-between mb-3">
                  <div className="search-wrapper w-30 ml-2">
                    <div className="grey-text ft-14">Search Fee</div>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <div className="search-icon-postion">
                          <i class="fas fa-search" aria-hidden="true"></i>
                        </div>
                      </InputGroup.Prepend>
                      <FormControlSearch
                        screen="manage-fee-page"
                        size="xs"
                        type="search"
                        className="plan-search-box pad-left-search"
                        placeholder="Search by Fee Name"
                        onChange={(e) => null}
                        onKeyPress={(e) => {
                          searchTextBox(e);
                        }}
                      />
                    </InputGroup>
                  </div>
                  <div className="pt-4">
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        setFilterSlider(true);
                      }}
                    >
                      Filter
                    </Button>
                  </div>
                </div>
                {!isEmpty(tags) && (
                  <div className="d-flex justify-content-between p-2">
                    <div className="d-flex">
                      <span className="grey-text mt-2 mr-3">Filters</span>
                      {!filterSlider && (
                        <div className="filter-tags marg-top-5 pad-top-15">
                          {flatTags.map((data, index) => {
                            if (index < 8)
                              return (
                                <div
                                  className="flex-start"
                                  style={{ width: "100px" }}
                                >
                                  <div className="fee-tags">
                                    {data.label?.length > 7 ? (
                                      <OverlayTrigger
                                        placement="top-start"
                                        overlay={
                                          <Tooltip>{data.label}</Tooltip>
                                        }
                                      >
                                        <div className="filter-text">
                                          {(data.label || "").slice(0, 5)}
                                          {data.label?.length > 5
                                            ? "..."
                                            : null}
                                        </div>
                                      </OverlayTrigger>
                                    ) : (
                                      <div className="filter-text">
                                        {data.label}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                          })}
                        </div>
                      )}
                    </div>
                    {flatTags?.length > 8 && (
                      <div style={{ width: "10%" }}>
                        <Link
                          onClick={() => {
                            setFilterSlider(true);
                            setshowTags(true);
                          }}
                        >
                          View {flatTags.length - 8} +
                        </Link>
                      </div>
                    )}
                  </div>
                )}
                <div className="ml-2 grey-text">
                  {feeData?.length} Records found
                </div>
                <div className="p-3 d-flex align-center">
                  {header.map((name) => {
                    return (
                      <div
                        className="ft-14 grey-text"
                        style={{ width: name.width, textAlign: name.align }}
                      >
                        {name.name}
                        {/* <FontAwesomeIcon size="md" className="ml-2" icon={faSort} /> */}
                      </div>
                    );
                  })}
                </div>
                {feeData?.length == 0 ? (
                  <div
                    style={{
                      width: "30%",
                      top: "50%",
                      left: "40%",
                      position: "absolute",
                      fontSize: "20px",
                    }}
                  >
                    No Records Found
                  </div>
                ) : (
                  <div className="fee-scroll">
                    <InfiniteScroll
                      pageStart={0}
                      loadMore={() => {
                        setAppend(true);
                        setRequest((request) => {
                          return { ...request, from: feeData?.length };
                        });
                      }}
                      hasMore={!stopInfiniteScroll}
                      initialLoad={false}
                      threshold={100}
                      useWindow={false}
                      loader={
                        isLoading && (
                          <div className="loader" key={0}>
                            Loading ...
                          </div>
                        )
                      }
                    >
                      {feeData?.map((content) => {
                        return (
                          <div
                            className="fee-layout"
                            onClick={() =>
                              FeeDetailNavigate(content.id, content.step)
                            }
                          >
                            <FeeHomeCard
                              description={content.description}
                              header={header}
                              data={content}
                              dataWidth={dataWidth}
                              getStatus={getStatus}
                              isFeeDetails={true}
                            />
                          </div>
                        );
                      })}
                    </InfiniteScroll>
                  </div>
                )}
                <SliderPanel
                  isOpen={filterSlider}
                  showCancel={false}
                  backdropClicked={() => setFilterSlider(false)}
                >
                  <Form onSubmit={handleSubmit}>
                    <div className="disp-flex-row space-between fw-500 ft-18">
                      <p className="mt-2">Filter</p>
                      <div>
                        <Button
                          className="marg-right-10"
                          variant="secondary"
                          onClick={() => {
                            setFilterSlider(false);
                          }}
                        >
                          Cancel
                        </Button>
                        <Button className="w-100px" type="Submit">
                          Apply
                        </Button>
                      </div>
                    </div>

                    <div className="filters-count d-flex flex-col">
                      <div className="d-flex justify-content-space-between">
                        <div className="d-flex flex-col">
                          <span className="fw-500 ft-18">Selected Filter</span>
                          <span className="grey-text">
                            {feeTypeLength +
                              feeClassificationLength +
                              scheduleTypeLength +
                              feeStatusLength +
                              planLength}{" "}
                            Selected
                          </span>
                        </div>
                        <div className="Arrow-up">
                          {!isEmpty(tags) && (
                            <>
                              <Link
                                className="mr-3"
                                onClick={() => onClickClearAll(setFieldValue)}
                              >
                                Clear all
                              </Link>
                              <Link onClick={() => setshowTags(!showTags)}>
                                {!showTags ? (
                                  <FontAwesomeIcon icon={faChevronDown} />
                                ) : (
                                  <FontAwesomeIcon icon={faChevronUp} />
                                )}
                              </Link>
                            </>
                          )}
                        </div>
                      </div>
                      {showTags && (
                        <div className="filter-tags marg-top-5 pad-top-15">
                          {[1, 2, 3, 4, 5, 6, 7].map((filterIndex) =>
                            (tags[filterIndex] || []).map((data, index) =>
                              data.map((item, idx) => (
                                <div className="flex-start">
                                  <div className="tags">
                                    <div className="filter-text">
                                      {item.label}
                                    </div>
                                    <div className="filter-cross-icon">
                                      <Link
                                        onClick={() =>
                                          onDeleteFilterClick(
                                            values,
                                            setFieldValue,
                                            filterIndex,
                                            item.value
                                          )
                                        }
                                      >
                                        <i
                                          class="fa fa-times-circle fee-cross-icon-black"
                                          aria-hidden="true"
                                        ></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              ))
                            )
                          )}
                        </div>
                      )}
                    </div>

                    <div className="disp-flex-col overflow-Y H-80">
                      <div className="ft-12 mb-2">Plan Name & ID</div>
                      <div className="d-flex">
                        <Field
                          name={fields.planNameOrId}
                          value={values[fields.planNameOrId]}
                          options={planSearchOptions}
                          direction="bottom"
                          size="sm"
                          isRequired
                          popupContent={
                            <SearchableList
                              label="Select Plan Id Or Name"
                              isNotTypeAhead
                              isRadio
                              width="200px"
                              name={fields.planNameOrId}
                              options={planSearchOptions}
                              overflow
                              onSelect={(value) => {
                                setFieldValue(fields.planNameOrId, value);
                                setPlanNameOrId(value);
                              }}
                              selectedValue={values[fields.planNameOrId]}
                            />
                          }
                          component={FieldDropSide}
                        />
                        <Field
                          name={fields.planId}
                          value={values[fields.planId]}
                          options={
                            values[fields.planNameOrId] == 1
                              ? planRkplandropdown
                              : planNamedropdown
                          }
                          direction="right"
                          placeholder={
                            values[fields.planNameOrId] == 1
                              ? "Select Plan Id"
                              : "Select Plan Name"
                          }
                          size="smd"
                          isRequired
                          popupContent={
                            <SearchableList
                              label={
                                values[fields.planNameOrId] == 1
                                  ? "Plan Id"
                                  : "Plan Name"
                              }
                              name={fields.planId}
                              options={
                                values[fields.planNameOrId] == 1
                                  ? planRkplandropdown
                                  : planNamedropdown
                              }
                              overflow
                              onSelect={(value, label) => {
                                setFieldValue(fields.planId, value);
                                handleFilters(5, [value]);
                              }}
                              value={values[fields.planId]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <Field
                        isRequired
                        name={fields.feeType}
                        label={"Fee Type"}
                        options={feeTypeOptions}
                        selectedValue={values[fields.feeType]}
                        value={values[fields.feeType]}
                        onChange={(value) => {
                          setFieldValue(fields.feeType, value);
                          handleFilters(1, value);
                        }}
                        component={FieldMultiSelectButtonGroup}
                      />
                      <Field
                        label="Fee Classification"
                        name={fields.feeClassificationIds}
                        value={toMultiSelectValueById(
                          values[fields.feeClassificationIds],
                          feeClassificationsResult
                        )}
                        direction="right"
                        placeholder="All"
                        size="smd"
                        isRequired
                        isMultiSelect
                        popupContent={
                          <MultiSelectDropdown
                            label="Fee Classification"
                            name={fields.feeClassificationIds}
                            options={feeClassificationsResult}
                            overflow
                            onSelect={(value) => {
                              setFieldValue(fields.feeClassificationIds, value);
                              handleFilters(2, value);
                            }}
                            value={values[fields.feeClassificationIds]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        isRequired
                        name={fields.feeRunType}
                        label="Fee Run type"
                        size="sm"
                        options={feeRunTypeOptions}
                        selectedValue={values[fields.feeRunType]}
                        onChange={(value) => {
                          setFieldValue(fields.feeRunType, value);
                          handleFilters(3, [value]);
                        }}
                        component={FieldButtonGroup}
                      />
                      <Field
                        isRequired
                        name={fields.feeStatus}
                        label="Fee status"
                        size="sm"
                        options={statusOptions}
                        selectedValue={values[fields.feeStatus]}
                        onChange={(value) => {
                          setFieldValue(fields.feeStatus, value);
                          handleFilters(4, [value]);
                        }}
                        component={FieldButtonGroup}
                      />
                    </div>
                  </Form>
                </SliderPanel>
              </>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </ManageFeeLayout>
  );
};

export default ManageFeeContainer;
